var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-tree"},[_c('Tree',_vm._g(_vm._b({ref:"tree",attrs:{"render":_vm.renderContent,"data":_vm.treeData,"show-checkbox":"","multiple":""},on:{"on-check-change":_vm.getCheckedNodes}},'Tree',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }